<div class="cmn-dialog-card-view">
    <button class="dialog-close-btn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>
    <mat-dialog-content>
        <div class="dialog-body">
            <iframe class="terms-iframe" [src]="link" frameborder="0"></iframe></div
    ></mat-dialog-content>
</div>
